"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var entries = [{
  label: "Move Forward",
  value: "W"
}, {
  label: "Move Backward",
  value: "S"
}, {
  label: "Move Left, Turn",
  value: "A"
}, {
  label: "Move Right, Turn",
  value: "D"
}, {
  label: "Sit Down / Stand Up",
  value: "X"
}, {
  label: "Walk / Run",
  value: "R"
}, {
  label: "Offensive / Peace",
  value: "Q"
}, {
  label: "Sprint",
  value: "F"
}, {
  label: "Jump",
  value: "Space"
}, {
  label: "Auto Run",
  value: "Tab"
}, {
  label: "Equipment Window",
  value: "I"
}, {
  label: "Status Window",
  value: "C"
}, {
  label: "Skill Window",
  value: "K"
}, {
  label: "Mini Map",
  value: "M"
}, {
  label: "Party Window",
  value: "P"
}, {
  label: "Hide Interface",
  value: "~"
}, {
  label: "Close Window",
  value: "Esc"
}, {
  label: "Screenshot",
  value: "Pr Sc"
}, {
  label: "Switch Perspective",
  value: "F12"
}, {
  label: "Pet Skill 1",
  value: "F1"
}, {
  label: "Pet Skill 2",
  value: "F2"
}, {
  label: "Pet Skill 3",
  value: "F3"
}, {
  label: "Pet Skill 4",
  value: "F4"
}, {
  label: "Pet Skill 5",
  value: "F5"
}, {
  label: "Target the Nearest NPC",
  value: "F6"
}, {
  label: "Target the Nearest PC",
  value: "F7"
}, {
  label: "Target the Nearest NPC/PC",
  value: "F8"
}, {
  label: "Target Yourself",
  value: "F9"
}, {
  label: "Help",
  value: "F11"
}, {
  label: "Whisper",
  value: "T"
}, {
  label: "Reply to Whipser",
  value: "Y"
}, {
  label: "Party",
  value: "G"
}, {
  label: "Exchange Weapon",
  value: "E"
}, {
  label: "Guild",
  value: "N"
}, {
  label: "Zoom In",
  value: "Up"
}, {
  label: "Zoom Out",
  value: "Down"
}, {
  label: "Rotate Left",
  value: "Left"
}, {
  label: "Rotate Right",
  value: "Right"
}, {
  label: "Rotate 180 Degrees",
  value: "End"
}, {
  label: "Quest Window",
  value: "U"
}, {
  label: "Auto Loot",
  value: "V"
}];
var _default = entries;
exports.default = _default;